import { render, staticRenderFns } from "./building-search.locale-selector.vue?vue&type=template&id=568e5344&"
import script from "./building-search.locale-selector.vue?vue&type=script&lang=ts&"
export * from "./building-search.locale-selector.vue?vue&type=script&lang=ts&"
import style0 from "./building-search.locale-selector.vue?vue&type=style&index=0&id=568e5344&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports